"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MineWrapper = void 0;
const web3_js_1 = require("@solana/web3.js");
const pda_1 = require("./pda");
const rewarder_1 = require("./rewarder");
class MineWrapper {
    constructor(sdk) {
        this.sdk = sdk;
    }
    get provider() {
        return this.sdk.provider;
    }
    get program() {
        return this.sdk.programs.Mine;
    }
    createRewarder({ mintWrapper, baseKP = web3_js_1.Keypair.generate(), authority = this.program.provider.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const [rewarderKey, bump] = yield (0, pda_1.findRewarderAddress)(baseKP.publicKey, this.program.programId);
            const mintWrapperData = yield this.sdk.programs.MintWrapper.account.mintWrapper.fetch(mintWrapper);
            return {
                key: rewarderKey,
                tx: this.sdk.newTx([
                    this.program.instruction.newRewarder(bump, {
                        accounts: {
                            base: baseKP.publicKey,
                            authority,
                            rewarder: rewarderKey,
                            payer: this.program.provider.wallet.publicKey,
                            systemProgram: web3_js_1.SystemProgram.programId,
                            clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                            mintWrapper,
                            mintWrapperProgram: this.sdk.programs.MintWrapper.programId,
                            rewardsTokenMint: mintWrapperData.tokenMint,
                        },
                    }),
                ], [baseKP]),
            };
        });
    }
    /**
     * Loads the rewarder wrapper.
     * @param rewarder
     * @returns
     */
    loadRewarderWrapper(rewarder) {
        return __awaiter(this, void 0, void 0, function* () {
            const rewarderData = yield this.program.account.rewarder.fetch(rewarder);
            return new rewarder_1.RewarderWrapper(this, rewarder, rewarderData);
        });
    }
}
exports.MineWrapper = MineWrapper;
//# sourceMappingURL=mine.js.map